/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Languages_LabelInputs */

const en_mcp_languages_label = /** @type {(inputs: Mcp_Languages_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Languages`)
};

const es_mcp_languages_label = /** @type {(inputs: Mcp_Languages_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idiomas`)
};

/**
* | output |
* | --- |
* | "Languages" |
*
* @param {Mcp_Languages_LabelInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_languages_label = /** @type {((inputs?: Mcp_Languages_LabelInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Languages_LabelInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_languages_label(inputs)
	return en_mcp_languages_label(inputs)
});